import { UserAttributeKind } from '@hotjar/webapp/domains/user-attributes/model';

export enum UserAttributeDtoKind {
  STR = 'string',
  BOOL = 'boolean',
  DATE = 'date',
  EMAIL = 'email',
  NUMBER = 'number',
  UNKNOWN = 'unknown',
}

export const UserAttributeToDto: Record<UserAttributeKind, UserAttributeDtoKind> = {
  [UserAttributeKind.String]: UserAttributeDtoKind.STR,
  [UserAttributeKind.Boolean]: UserAttributeDtoKind.BOOL,
  [UserAttributeKind.Date]: UserAttributeDtoKind.DATE,
  [UserAttributeKind.Email]: UserAttributeDtoKind.STR, // this is intentional, BE doesn't support email rule_type
  [UserAttributeKind.Number]: UserAttributeDtoKind.NUMBER,
  [UserAttributeKind.Unknown]: UserAttributeDtoKind.UNKNOWN,
};

export const UserAttributeKindByStringDtoValue: Record<UserAttributeDtoKind, UserAttributeKind> = {
  [UserAttributeDtoKind.STR]: UserAttributeKind.String,
  [UserAttributeDtoKind.BOOL]: UserAttributeKind.Boolean,
  [UserAttributeDtoKind.DATE]: UserAttributeKind.Date,
  [UserAttributeDtoKind.EMAIL]: UserAttributeKind.Email,
  [UserAttributeDtoKind.NUMBER]: UserAttributeKind.Number,
  [UserAttributeDtoKind.UNKNOWN]: UserAttributeKind.Unknown,
};
